import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=58b42e1f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=58b42e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b42e1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b42e1f')) {
      api.createRecord('58b42e1f', component.options)
    } else {
      api.reload('58b42e1f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=58b42e1f&scoped=true&", function () {
      api.rerender('58b42e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-230n7phGQOPEg/JS/teamMember.vue"
export default component.exports